import React, { useEffect, useState } from 'react'
import ConsultasComunes from '../Sql/ConsultasComunes'
import MsgUtils from '../Tools/MsgUtils';
import ItemEstadoSucursal from './ItemEstadoSucursal';
function PrincipalEstadoSucursales() {
    const [regional,setRegional] = useState('');
    const [sucursales,setSucursales] = useState([]);
    const [actualizar,setActualizar] = useState(false);
    const getSucursales=async(region)=>{
        try {
            var listaSuc = await ConsultasComunes.getSucursales(region);
            if(listaSuc.ok){
                console.log(listaSuc.ok);
                setSucursales(listaSuc.ok);
            }else{
                MsgUtils.msgError(listaSuc.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(()=>{
        if(regional==''){
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            setRegional(info.regional)
            getSucursales(info.regional);
        }else{
            getSucursales(regional);
        }
    },[regional])
    return (
        <>
            <div className='bg-dark bg-gradient container-fluid py-1'>
                <div className='row row-cols-2 gx-1'>
                    <div className='col-10'>
                        <div className='row row-cols g-1'>
                            <div className='col' style={{ minWidth: '240px', maxWidth: '240px' }}>
                                <div className="input-group input-group-sm my-auto">
                                    <span className="input-group-text bg-transparent text-light" style={{border:'none'}}>Regional</span>
                                    <select className=" form-select text-center "
                                        value={regional} onChange={(e) => setRegional(e.target.value)}
                                    >
                                        <option value='990'>CBBA</option>
                                        <option value='991'>SCRZ</option>
                                    </select>
                                </div>
                            </div>
                            <div className='col' style={{ minWidth: '130px', maxWidth: '130px' }}>
                                <button className='btn btn-sm btn-success w-100' 
                                    onClick={()=>setActualizar(!actualizar)}>
                                        <i className="fa-solid fa-spinner"></i> Actualizar</button>
                            </div>
                        </div>
                    </div>
                    <div className='col-2'>

                    </div>
                </div>
            </div>
            <div className='container-fluid py-2'>
                <div className='row row-cols g-1'>
                    {sucursales.map((item,index)=>{
                        return(
                            <div className='col' style={{maxWidth:'470px',minWidth:'300px'}} key={index}>
                                <ItemEstadoSucursal sucursalinfo={item} actualizar={actualizar}/>
                            </div>  
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default PrincipalEstadoSucursales